module.exports = __webpack_public_path__ + "static/media/4.026de4f1.JPG";